import React, { useEffect } from 'react'
import className from 'classnames/bind'

import style from './MyhouseRegisterTermsCollect.module.scss'

import { lcsSend } from '@Helpers/lcs'
import { NDS_PROTOCOL } from '@Root/contants/lcs'

const cx = className.bind(style)

const MyhouseRegisterTermsCollect: React.FC = () => {
  useEffect(() => {
    lcsSend(NDS_PROTOCOL.MY_HOUSE.REGISTER.TERM_COLLECT)

    window.scrollTo(0, 0)
  }, [])

  return (
    <div className={cx('terms')}>
      <h3 className={cx('title')}>개인정보 수집 및 이용 동의</h3>
      <dl className={cx('list')}>
        <dd className={cx('text')}>
          ‘네이버파이낸셜㈜’는 네이버파이낸셜 회원들의 개인(신용)정보를 안전하게 처리하는데 최선을 다합니다. 네이버파이낸셜 서비스 이용을 위해서는 아래의 개인(신용)정보 동의가
          필요합니다. 자세히 읽은 후 동의하여 주시기 바랍니다.
        </dd>
      </dl>
      <dl className={cx('list')}>
        <dt className={cx('subtitle')}>1. 수집항목</dt>
        <dd className={cx('text')}>
          <span>
            [필수] 주소지, 매물유형, 주거형태, (자가)매입가, (전세)보증금, (월세)보증금과 월세, 평형정보(매물유형이
            아파트/오피스텔/주상복합/아파트분양권/오피스텔분양권/주상복합분양권인 이용자의 경우)
            <br />
            [선택] 건물명, 동, 호수, 면적(매물유형이 빌라/연립/단독/다가구/상가주택/상가/건물인 이용자의 경우 및 일부 아파트/오피스텔 이용자에 한함), (자가)보증금과 매입일자,
            (전/월세)입주일자와 만기일자
          </span>
        </dd>
      </dl>
      <dl className={cx('list')}>
        <dt className={cx('subtitle')}>2. 수집 및 이용 목적</dt>
        <dd className={cx('text')}>
          <span>
            법령 및 이용약관을 위반하는 회원에 대한 이용 제한 조치, 부정 행위를 포함하여 서비스의 원활한 운영에 지장을 주는 행위에 대한 방지 및 제재, 분쟁 조정을 위한 기록 보존,
            고객상담 및 민원처리 등 이용자 보호 및 서비스 운영.
            <br />
            인구통계학적 분석, 이용자에게 유용한 네이버파이낸셜 서비스의 콘텐츠 및 기존 서비스 제공에 더하여, 개인정보 및 관심에 기반한 맞춤형 서비스(광고 포함) 제공, 신규 서비스
            요소의 발굴 및 기존 서비스 개선
          </span>
        </dd>
      </dl>
      <dl className={cx('list', 'type_emphasis')}>
        <dt className={cx('subtitle')}>3. 보유 및 이용기간</dt>
        <dd className={cx('text')}>서비스 종료 및 탈퇴 시까지(단, 관련 법령에 따라 별도 보관이 필요한 경우 해당 법령에서 정하는 기간만큼 보관함)</dd>
      </dl>
      <dl className={cx('list')}>
        <dd className={cx('text')}>
          <span>
            개인(신용)정보주체는 위 개인(신용)정보 동의를 거부할 권리가 있으나, 위 동의는 서비스 제공을 위해 필수적이므로 거부 시 서비스 제공에 제한을 받을 수 있습니다. 그 밖의
            사항은 네이버파이낸셜 개인정보 처리방침에 따릅니다.
          </span>
        </dd>
      </dl>
    </div>
  )
}

export default MyhouseRegisterTermsCollect
